import { damp, clamp } from '@utils/math/maths.js';
import { raf } from '@utils/performance/raf.js';

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));


export default function Preloader(base) {
    const counter = base.querySelector('.preloader__counter');
    const bg = base.querySelector('.preloader__bg');

    let progressTarget = 0;
    let progressCurrent = 0;
    let _completed = false;
    let _enterTime = 0;
    let _resolveFinished;
    const progressFinished = new Promise(resolve => { _resolveFinished = resolve; });


    function enter() {
        _enterTime = performance.now();
        raf.add(update);
    }


    function complete() {
        _completed = true;
        progressTarget = 1;
    }


    function update(dt) {
        // Slowly fake progress up to 90% while real loading is in progress
        if (!_completed) {
            const elapsed = (performance.now() - _enterTime) / 1000;
            progressTarget = Math.min(0.9, elapsed * 0.12);
        }

        dt = clamp(dt, 5, 300);
        let next = damp(progressCurrent, progressTarget, 0.17, dt);
        if (next > 0.99) next = 1;
        if (next === progressCurrent) return;
        progressCurrent = next;

        if (counter) {
            counter.textContent = Math.floor(progressCurrent * 100).toString().padStart(3, '0');
        }

        if (progressCurrent >= 1) _resolveFinished();
    }


    async function exit(done) {
        complete();
        await progressFinished;

        bg.style.transition = 'transform 1000ms cubic-bezier(0.910, 0.000, 0.195, 0.990)';
        bg.style.transform = 'scaleY(0)';
        await wait(400);

        if (counter) {
            counter.style.transition = 'opacity 200ms';
            counter.style.opacity = '0';
        }
        await wait(100);

        done();

        await wait(1000);
        raf.remove(update);
        base.remove();
    }


    return { enter, complete, exit };
}
